import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { ConfirmProvider } from './components/shared/ConfirmProvider'
import { readUrlFlagsAndPersist } from './lib/featureFlags'
import './index.css'

// Read v2 feature flags from the URL into sessionStorage BEFORE React
// mounts. ?v2=schedule (or ?v2=off) takes effect on the first render
// of any route; internal navigation thereafter doesn't need to thread
// the query param. See src/lib/featureFlags.ts.
readUrlFlagsAndPersist(window.location.search)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 30_000
    }
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
)